import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { FooterFull } from "../../../components/FooterFull";

import {
  Screen1,
  Learn,
  Themes,
  Structure,
  How,
  Reg
} from "../../../components/LandingTemplates/eng_for_it";

const TITLE = 'Английская лексика для IT | Центр образовательных технологий Advance';
const DESCRIPTION = 'Базовая английская лексика для работы в IT для начинающих | Центр образовательных технологий Advance ✅Уникальные методики обучения ✅ Эффективное запоминание материала ✅100% результат ☝️ Заходите!';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION} gcCounter={true}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({ widget = <GetCourseWidget hash={'95d0f027b1d60e4ad3312f5313dbf2dbf0c4a201'} id={'1261225'}/> }) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main style={{ color: "#343A40" }}>
      <Screen1/>
      <Learn/>
      <Themes/>
      <Structure/>
      <How/>
      <Reg widget={widget}/>
    </main>

    <FooterFull />
  </DefaultLayout>
);
export default Page;
